var React = require('react');

function IconCss (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H25.9459L23.5861 26.9538L12.9446 30L2.36232 26.9525L0 0ZM21.1151 5.51625L4.83089 5.5125L5.09405 8.79L17.6037 8.7925L17.2886 12.1875H9.08479L9.38131 15.4037H17.0193L16.5671 19.8075L12.9717 20.8125L9.31954 19.8L9.08726 17.1625H5.86255L6.22085 21.9812L12.973 24.11L19.6114 22.1975L21.1151 5.5175V5.51625Z","fill":"#fff"}));
}

IconCss.defaultProps = {"width":"26","height":"30","viewBox":"0 0 26 30","fill":"none"};

module.exports = IconCss;

IconCss.default = IconCss;
